import Vue from 'vue';
if(document.getElementById('partner-list')) {
    var partnerList = new Vue({
        el: "#partner-list",
        data: {
            partners: {},
            page: 1,
            load: false,
            pageCount: 0,
            partnerQuery: '',
            getLectionTime: null
        },
        mounted: function () {
            this.fetchPartners();
        },
        methods: {
            fetchPartners: function (append) {
                var self = this;

                this.load = true;

                try {

                    var data = {name: this.partnerQuery};

                    // console.lo

                    $.extend(data, {page: this.page});

                    $.ajax({
                        url: '/api/v1/partner',
                        dataType: "json",
                        data: data,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {

                                    self.partners.items.push(item);

                                });

                            } else {

                                self.partners = data;
                                // self.pageCount = data._meta.pageCount;
                                // self.page = 1;

                            }
                            self.load = false;

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    console.error(e);

                }
            },
            nextPage: function () {

                this.page = this.page + 1;
                this.fetchPartners(true);

            }
        }


    });

}